import React, { useState } from 'react';
import AdminLayout from '../../../components/layout/AdminLayout';
import FarmStatusForm from '../../../components/forms/FarmStatusForm';
import { useFarmStatusApi } from '../../../hooks/useFarmStatusApi';
import { useNavigate } from 'react-router-dom';
import Card from '../../../components/common/Card';
import { FarmStatusDTO } from '../../../services/apiClient';

const FarmStatusCreate: React.FC = () => {
  const { create, isLoading } = useFarmStatusApi();
  const navigate = useNavigate();

  const breadcrumbs = [
    { label: 'Admin', href: '#' },
    { label: 'Farm Statuses', href: '/admin/farmstatuses' },
    { label: 'Create', href: '#' },
  ];

  const handleSubmit = async (data: FarmStatusDTO) => {
    try {
      await create(data);
      navigate('/admin/farmstatuses');
    } catch (error) {
      console.error('Error creating FarmStatus:', error);
    }
  };

  return (
    <AdminLayout
      activeMenuItem="/admin/farmstatuses"
      breadcrumbs={breadcrumbs}
      allowedRoles={['Admin']}
      requiredPermission="Settings.FarmStatus.Edit"
    >
        <FarmStatusForm
          initialValues={{} as FarmStatusDTO}
          onSubmit={handleSubmit}
          onCancel={() => navigate('/admin/farmstatuses')}
        />
    </AdminLayout>
  );
};

export default FarmStatusCreate;
